import React from 'react';
import moment from 'moment';
import {
  Container,
  Header,
  Segment,
  Icon,
  Image,
  Grid,
  Step,
  Button,
  Card,
  Label,
  Table,
  Dimmer
} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import DivWrapper from './DivWrapper';

import {FormattedMessage} from 'react-intl';
import appPreview from '../img/app_preview.png';
import Counter from './Counter';

import applePic from '../img/apple-badge.png';
import googlePlayPic from '../img/google-play-badge.png';

import { BACKGROUND_DARK, BACKGROUND_DARK2, PRIMARY_COLOR } from '../constants';
import AudoryCoinIcon from '../img/AudoryCoinIcon';

const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            inverted
            style={{
            fontSize: mobile ? '1.2em' : '2.5em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.b2b.headText"/>
        </Header>
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.5em',
            fontWeight: 'normal',
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.b2b.bodyText"/>
        </Header>
        
        </Container>
    </Segment>
)

class B2BPage extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            audioSrc: null,
            audio: {},
            activePay: null,
        };
    }


    render(){
        return (
            <DivWrapper>
                <PageHeader />
              <Segment style={{ padding: '3em 0em', margin: 0 }}>
                  
                  <Container>
                    <Header as='h2' style={{ fontSize: '2.8em', marginBottom: '0.5em' }}>
                    Interaktives Marketing
                    </Header>
                    <p style={{ fontSize: '1.33em', textAlign: 'justify'}}>
                        Mit interaktiven Hörbüchern/ Hörspielen/ Podcasts haben Sie unzählige Möglichkeiten Ihre Zielgruppe besser kennenzulernen und gezielt zu werben.
                        Zum Beispiel hat die <a href={"https://tu-chemnitz.de"} target='_blank' style={{color: PRIMARY_COLOR}}>Technische Universität Chemnitz</a> mit uns eine interaktive Studienorientierung entwickelt,
                        bei der Schülerinnen und Schüler ein Abenteuer-Hörbuch hören, nebenbei Chemnitz kennenlernen und ihnen anschließend anhand der Entscheidungen, die sie im Hörbuch getroffen haben,
                        die für sie passende Studienrichtung an der TU Chemnitz vorgeschlagen wird.
                    </p>
                    <center>
                        <Image bordered rounded size='huge' src='https://audory-static.s3.eu-central-1.amazonaws.com/tuc_max_audory.jpg' />
                    </center>
                        <Grid style={{marginTop: '0.5em'}}>
                            <Grid.Column textAlign='center'>
                                <a href={"https://www.tu-chemnitz.de/tu/pressestelle/aktuell/11062"} target='_blank'>
                                    <Button labelPosition='right' icon='right chevron' size='huge' content='Zum Pressebeitrag' />
                                </a>
                            </Grid.Column>
                        </Grid>

                    <Grid columns={1} divided textAlign='center' stackable>
                        <Grid.Column>
                            <Grid.Row verticalAlign='middle'>
                                <p style={{ fontSize: '1.33em', padding: '1.5em', textAlign: 'justify' }}>
                                    "Als TU Chemnitz war es uns wichtig, neben den zahlreichen Websites, Studienwahlplattformen oder Assessments ein neues Format auszuprobieren, das nicht sofort mit Studienorientierung assoziiert wird. Unter einem interaktiven Hörbuch zur Studienorientierung konnten wir uns zu Beginn noch nicht viel vorstellen und waren auf die Umsetzung gespannt. Audory übernahm die Organisation, die Auswahl der Autorin und Sprecher, die sich um die Inhalte sowie Vertonung der Geschichte kümmerten. In die Abläufe wurden wir stets eingebunden. Wir danken allen Beteiligten für die unkomplizierte Zusammenarbeit, die Koordination, den Ideenreichtum und das Ergebnis - eine wunderbare und so lebensnahe interaktive Geschichte."
                                </p>
                            </Grid.Row>
                            <Grid.Row verticalAlign='middle'>
                                    <Image avatar style={{marginRight: '2em'}} src={"https://audory-static.s3.eu-central-1.amazonaws.com/b2b/tuc_monique_reuther.jpg"} size="small" />
                                    <Table style={{ fontSize: '1.33em', margin: 'auto' }} collapsing basic='very'>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell textAlign='center'>
                                                <b>Monique Reuther</b>
                                                </Table.Cell>
                                                <Table.Cell>
                                                TUCdiscover Projektmitarbeiterin
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                            </Grid.Row>
                        </Grid.Column>
                        
                    </Grid>

                    
                  <Grid container stackable verticalAlign='middle'>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Header as='h3' style={{ fontSize: '1.8em' }}>
                                Erst verstehen, dann verstanden werden
                            </Header>
                            <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                                Wie in einem digitalisierten "1 zu 1" - Gespräch können Sie beraten und individuell auf jede einzelne Person eingehen, die sich damit besser verstanden fühlt.
                            </p>

                            <Header as='h3' style={{ fontSize: '1.8em' }}>
                                Innovative Art einer Nutzer-Umfrage
                            </Header>
                            <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                            Sie möchten herausfinden, was Ihrer Community wirklich gefällt?
                            Erzählen Sie eine mitreißende Geschichte und erfahren Sie anhand unserer Entscheidungs-Statistiken an welchen Stellen sich die Mehrheit Ihrer Community wie entscheidet.
                            Optimieren Sie Ihr Produkt oder Ihre Dienstleistung perfekt nach den Wünschen Ihrer Kunden!
                            </p>
                        </Grid.Column>
                        <Grid.Column floated='right' width={6}>
                            <Image bordered rounded size='large' src='https://audory-static.s3.eu-central-1.amazonaws.com/tuc_klassenfahrt.jpeg' />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column textAlign='center'>
                            <Link to={"/play/61b23053f7f807097d676fc1"} target='_blank'>
                                <Button labelPosition='right' icon='right chevron' size='huge' content='Zur Geschichte' />
                            </Link>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
          
                      <Header as='h2' style={{ fontSize: '2.8em', marginTop: '2em' }}>
                        Interaktive Messen
                      </Header>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                        Als Besucher einer Messe hat man häufig das Problem, dass es so viele Messestände gibt, dass man nicht die Zeit hat alle Stände zu besuchen. Die bisherige Lösung ist ein Messeplan, der zuvor als Flyer entworfen wurde.
                        Nachdem der Besucher alle Inhalte gelesen hat, kann er gezielt entscheiden wohin er gehen möchte.
                        <br />
                        Eine innovative Ergänzung kann eine interaktive Umfrage sein, die mithilfe unseres Editors erstellt wurde. Der Besucher scannt einen QR-Code ab, kommt auf eine Seite und kann entweder dort oder über Whatsapp ein paar Fragen beantworten.
                        Nachdem er seine Interessen kommuniziert hat, wird automatsich auf dieser Grundlage der passende Messestand vorgeschlagen und wie er dort hin gelangt.
                      </p>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '1em' }}>
                        Damit bekommt der Besucher die Möglichkeit schnell und unkompliziert die große Auswahl an Messeständen nach seinen Interessen zu filtern.
                      </p>

                    <center>
                        <Image bordered rounded size='huge' src='https://audory-static.s3.eu-central-1.amazonaws.com/audory_messe.jpg' />
                    </center>
                      
                    <Header as='h2' style={{ fontSize: '2.8em', marginTop: '2em' }}>
                        Achtung, uns ist Datenschutz wichtig!
                      </Header>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '3em' }}>
                        Bei audory können Sie nicht auf personenbezogene Daten der Nutzer zugreifen. Diese sind Eigentum unserer Hörer und sie geben uns diese Daten um auf sich zugeschnittene Angebote und Vorschläge zu erhalten.
                        Im ersten Moment klingt das nach einem Nachteil für Sie, jedoch profitieren auch Sie von diesem klaren Datenschutz, da uns unsere Nutzer in diesem Rahmen gerne Daten zur Verfügung stellen!
                        So erhalten wir viele qualitativ hochwertige Daten, die auch die statistische Qualität ihrer Umfragen steigert.
                      </p>
          
                      <Header as='h2' style={{ fontSize: '2.8em', marginTop: '2em' }}>
                          Haben Sie Interesse an einer Zusammenarbeit?
                      </Header>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                        Durch unser Netzwerk aus professionellen Autoren, Tonstudios und Sprechern können wir entweder die gesamte Produktion übernehmen oder Teile davon.
                        Sollten Sie alle Komponenten selbst entwickeln wollen, können Sie das mithilfe unserer <Link to="/editor" style={{color: PRIMARY_COLOR}}>kostenlosen Editorsoftware</Link> tun.
                        Unternehmensproduktionen sind sehr individuell. Kommen Sie gerne für eine passende Beratung auf uns zu und schreiben sie und eine E-Mail an <a style={{color: PRIMARY_COLOR}} target='_blank' href="mailto:max.rose@audory.de?subject=Unternehmensproduktion%20%3CUNTERNEHMEN%20X%3E&body=Lieber%20Max%2C%0D%0A%0D%0Awir%20haben%20Interesse%20an%20einer%20Unternehmensproduktion%20im%20Bereich%20%5B...%5D%0D%0A%0D%0AMit%20freundlichen%20Gr%C3%BC%C3%9Fen%0D%0A%3CNAME%3E">max.rose@audory.de</a>!
                      </p>

                    <center>
                        <a target='_blank' href={"mailto:max.rose@audory.de?subject=Unternehmensproduktion%20%3CUNTERNEHMEN%20X%3E&body=Lieber%20Max%2C%0D%0A%0D%0Awir%20haben%20Interesse%20an%20einer%20Unternehmensproduktion%20im%20Bereich%20%5B...%5D%0D%0A%0D%0AMit%20freundlichen%20Gr%C3%BC%C3%9Fen%0D%0A%3CNAME%3E"}>
                            <Button labelPosition='right' icon='mail' size='huge' content='E-Mail schreiben' />
                        </a>
                    </center>

                          
                  </Container>
              </Segment>
            </DivWrapper>
          );
    }
} 



export default B2BPage;


// WEBPACK FOOTER //
// ./src/components/B2BPage.js